/* eslint-disable dot-notation */
import React from 'react';
import ApiDocsLoadableWrapped from '../ApiDocsLoadableWrapped';

const ManageApiDoc = () => (
  <ApiDocsLoadableWrapped
    jsonUrl={`${process.env['API_URL']}/kernel/main/full-doc`}
  />
);

export default ManageApiDoc;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/ApiDoc/ManageApiDoc/index.js